export enum EInventoryRoute {
  LOAD_EMPTY = 'loadEmpty',
  LOADS = 'LOADS',
  EMPTIES = 'EMPTIES',
  ALL = 'ALL',
  NONE = '',
  REPORT = 'report',
  CAR_HANDLING = 'car-handling',
  SHORT_LIST = 'short-list',
  CHARGES = 'charges',
  TYPE = 'type',
  HISTORY = 'history',
  STORAGE = 'storage',
  DEMURRAGE = 'demurrage',
  INBOUND = 'inbound',
  EMPTY_CAR = 'empty-car',
  ONSITE = 'ONSITE',
  ORDER_FILL = 'order-fill',
  TRACKBY = 'TRACKBY',
  SHIPPING = 'SHIPPING',
  RECEIVING = 'RECEIVING',
  AVPL = 'AVPL',
  PIPELINE = 'PIPELINE',
  INPROGRESS = 'INPROGRESS',
  LEASE = 'LEASE',
  QO = 'QO',
}

export enum EInventoryReport {
  CAR_HANDLING_REPORT = 'Car Handling Report',
  SHORT_LIST_REPORT = 'Short List Report'
}

export enum EInventoryTab {
  AVPL = 'AVAILABLE FOR PLACEMENT',
  PIPELINE = 'PIPELINE',
  IN_PROGRESS = 'IN PROGRESS',
  LEASE_TRACK = 'LEASE TRACK',
  QUANTITY_ORDER = 'QUANTITY ORDER',
  INBOUND_VISUALIZATION = 'INBOUND VISUALIZATION',
  INTRA_PLANT_SWITCH = 'INTRA-PLANT SWITCH',
  INTRA_TERMINAL_SWITCH = 'INTRA-TERMINAL SWITCH',
  PULL_TURN = 'PULL TURN',
  PULL_WEIGHT = 'PULL WEIGHT',
  ORDER_NOT_USED = 'ORDER NOT USED',
  CHARGEABLE_REASON_CODE = 'CHARGEABLE REASON CODE',
  LATE_SURRENDER = 'LATE SURRENDER',
  LEASE_TRACK_OVERAGES = 'LEASE TRACK OVERAGES',
  TERMINATING = 'TERMINATING',
  TERMINATING_DEMURRAGE = 'TERMINATING DEMURRAGE',
  PRIVATE_CAR_STORAGE = 'PRIVATE CAR STORAGE',
  ORIGINATING = 'ORIGINATING',
  ORIGINATING_DEMURRAGE = 'ORIGINATING DEMURRAGE',
  ORIGINATING_STORAGE = 'ORIGINATING STORAGE',
  ASSIGNED_CAR_STORAGE = 'ASSIGNED CAR STORAGE',
  PENDING_DISPUTES = 'PENDING DISPUTES',
  DISPUTE_HISTORY = 'DISPUTE HISTORY',
  ONSITE = 'ONSITE',
  TRACK_BY_CLASS = 'TRACK BY CLASS',
  SHIPPING = 'SHIPPING'
}

export enum ERequestType {
  SR = 'SR',
  RR = 'RR',
  PR = 'PR'
}

export enum EReleaseSwitchType {
  ONSITE = 'ONSITE',
  SIP = 'SIP'
}

export enum EOrderType {
  AVPL = 'AVPL',
  LETR = 'LETR',
  PIPE = 'PIPE'
}

export enum EOrderAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  RE_ORDER = 'reOrder'
}

export enum EBillingType {
  PCS = 'DE_PCS',
  EACS = 'DE_EACS',
  OS = 'DE_OS',
  TD = 'DE_TD',
  OD = 'DE_OD',
  D = 'D',
  S = 'S'
}

export enum EAccrualType {
  OPEN = 'open',
  CLOSE = 'close'
}

export enum EInventoryParamType {
  CLASS_CODE = 'classCode',
  CAR_TYPE = 'carType',
  LOAD_EMPTY = 'loadEmpty',
  DISPUTE_REASON = 'disputeReason',
  SUSPENSION_REASON = 'suspensionReason',
  DISPUTE_COMMENT = 'disputeComment',
  SUSPENSION_COMMENT = 'suspensionComment',
  SERVICE_CREDITS = 'serviceCredits',
  ADJUSTED_CREDITS = 'adjustedCredits',
  CREDITS = 'credits',
  APPROVED_BY = 'approvedBy',
  APPROVE = 'approve',
  SPOT = 'spot',
  HANDLING = 'handling',
  QUANTITY = 'quantity',
  TOTAL = 'total',
  PCON = 'pcon',
  NOPA = 'nopa',
  ORPL = 'orpl',
  PACT = 'pact',
  RELEASE = 'release',
  PFPS = 'pfps',
  SUSPENSION_START_DATE = 'suspensionStartEventDtm',
  SUSPENSION_END_DATE = 'suspensionEndEventDtm',
  DESTINATION_TRACK = 'destinationTrack',
}
